import React from 'react';
import styles from './TaskLayout.module.scss';

const toolbarStyle = {
  display: 'flex',
  marginBottom: 10,
  width: '100%',
  justifyContent: 'space-between',
  maxHeight: 'fit-content',
};

const toolbarLeftStyle = { display: 'flex', gap: 15 };

function TaskLayout({ left, right, children }) {
  return (
    <>
      <div className={styles['task-toolbar']}>
        <div className={styles['task-toolbar-left']}>{left}</div>
        <div className={styles['task-toolbar-right']}>{right}</div>
      </div>
      <div>{children}</div>
    </>
  );
}

export default TaskLayout;